import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider, Navigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import AppLandingPage from "./App";
import Dashboard from "./Dashboard";
import Login from "./login";
import Company from "./company";
import BusinessUnit from "./Businessunit";
import Sitelocation from "./sitelocation";
import Listofentities from "./listofentities";
import Listofbusinessunits from "./listofbusinessunits";
import ListSiteLocations from "./listsitelocations";
import Organizations from "./organizations";
import OrganizationNew from "./organizationNew";
import AddUser from "./adduser";
import Listofusers from "./listofusers";
import RequirePermission from "./components/RequirePermission";
import RequireFeature from "./components/RequireFeature";
import { PERMISSIONS } from "./constants/permissions";
import AllConfiguration from "./allconfiguration";
import ReportHistory from "./reporthistory";
import SiteAnomaliesPage from "./SiteAnomaliesPage";
import Report from "./report";
import Configration from "./configuration";
import Home from "./Home";
import Accessdenied from "./accessdenied";
import Comingsoon from "./comingsoon";
import ComingSoonForms from "./ComingSoonForms";
import Insights from "./insights";
import Assessinglowre from "./assessing-low-re";
import Electricitycostevaluation from "./electricity-cost-evaluation";
import Assessingelecusage from "./assessing-elec-usage";
import Reporting from "./reporting";
import GenerateReport from "./GenerateReport";
import DisplayLabels from "./displayLabels";
import Csrd1 from "./csrd1";
import ReportTable from "./ReportTable";
import Table from "./Table";
import FormApp from "./Form";
import Internal from "./internal";
import Standards from "./standards";
import Csrd from "./csrd";
import BrsrNewReport from "./BRSR/brsrNewReport";
import BrsrRepository from "./BRSR/brsrRepository";
import BrsrModule from "./BRSR/brsrModule";
import BrsrPreviewReport from "./BRSR/brsrPreviewReport";
import BrsrDashboard from "./BRSR/brsrDashboard";
import ReportDashboard from "./ReportDashboard";
import Carousel from "./demo";
import Social from "./social";
import Water from "./water";
import Demotable from "./demotable";
import Demonew from "./demonew";
import Scope2 from "./scope2";
import Scope1 from "./scope1";
import Newconfig from "./newconfig";
import Newallconfig from "./newallconfig";
import Neweditconfig from "./neweditconfig";
import EditConfiguration from "./editConfiguration";
import PreviewReport from "./PreviewReport";
import Materiality from "./Materiality";
import ReportingModules from "./ReportingModules";
import FormsApps from "./FormsApps";
import EmployeeCommuteSurvey from "./EmployeeCommuteSurvey";
import StartNewSurvey from "./StartNewSurvey";
import ECDashboard from "./ECDashboard";
import ECSurveyForm from "./ECSurveyForm";
import SCFData from "./SCFData";
import SCFSurvey from "./SCFSurvey";
import SCFSurveyForm from "./SCFSurveyForm";
import SCFEnergyEmissions from "./SCFEnergyEmissions";
import SCFScope from "./SCFScope";
import Repository from "./Repository";
import RepositoryAddLink from "./RepositoryAddLink";
import EditCSRD from "./editCsrd";
import EditMateriality from "./editMateriality";
import EditReportingModule from "./editReportingModule";
import EditGenerateReport from "./editGenerateReport";
import EditPreviewReport from "./editPreviewReport";
import ESGBenchmarking from "./ESGBenchmarking";
import Employeecommutedashboard from "./Employee-commute-dashboard";
import Businesstraveldashboard from "./Business-travel-dashboard";
import Transportationdistributiondashboard from "./Transportation-Distribution-Dashboard";
import Wastedashboard from "./Waste-dashboard";
import WasteFactorLibrary from "./WasteFactorLibrary";
import WasteSupplierFactors from "./WasteSupplierFactors";
import Travellogisticdashboard from "./Travel-Logistic-Dashboard";
import InternalReports from "./InternalReports";
import ESGDashboard from "./ESGDashboard";
import Profile from "./Profile";
import EmissionBenchmarking from "./Emission-benchmarking";
import EmissionTargets from "./Emission-targets";
import ESGReportingSF from "./ESG-reporting-SF";
import ESGHome from "./ESGHome";
import CsrdBenchmarking from "./Csrd-benchmarking";
import CsrdBenchmarkingV2 from "./CsrdBenchmarkingV2";
import ReportHistoryNew from "./ReportHistory2";
import DeepDivePage from "./DeepDive/DeepDivePage";
import EditConfig from "./EditConfig";
import PerformanceDashboardPage from "./PerformanceDashboardPage";
import Glossary from "./Glossary";
import FrameworkGuides from "./FrameworkGuides";
import AdvisorPage from "./AdvisorPage";

function ProtectedRoute({ children }) {
  const location = useLocation();
  const loginType = localStorage.getItem("loginType");
  if (loginType === "AAD") return children;
  const token = localStorage.getItem("JWT");
  if (!token) {
    localStorage.setItem("redirectAfterLogin", location.pathname);
    return <Navigate to="/login" replace />;
  }
  try {
    const decoded = jwtDecode(token);
    if (decoded.exp < Date.now() / 1000) {
      localStorage.removeItem("JWT");
      localStorage.setItem("redirectAfterLogin", location.pathname);
      return <Navigate to="/login" replace />;
    }
  } catch {
    localStorage.removeItem("JWT");
    localStorage.setItem("redirectAfterLogin", location.pathname);
    return <Navigate to="/login" replace />;
  }
  return children;
}

const router = createBrowserRouter([
  {
    path: "/",
    element: <AppLandingPage />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/callback",
    element: <Login />,
  },
  {
    path: "/Dashboard",
    element: <RequireFeature feature="dashboard"><Dashboard /></RequireFeature>,
  },
  {
    path: "/company",
    element: <RequirePermission permission={PERMISSIONS.MANAGE_ORG_STRUCTURE}><Company /></RequirePermission>,
  },
  {
    path: "/allconfiguration",
    element: <RequireFeature feature="configuration"><RequirePermission permission={PERMISSIONS.MANAGE_CONFIGURATION}><AllConfiguration /></RequirePermission></RequireFeature>,
  },
  {
    path: "/configuration",
    element: <RequireFeature feature="configuration"><RequirePermission permission={PERMISSIONS.MANAGE_CONFIGURATION}><Configration /></RequirePermission></RequireFeature>,
  },
  {
    path: "/report",
    element: <Report />,
  },
  {
    path: "/reporthistory",
    element: <ReportHistory />,
  },
  {
    path: "/site-anomalies",
    element: <RequireFeature feature="dashboard"><SiteAnomaliesPage /></RequireFeature>,
  },
  {
    path: "/Businessunit",
    element: <RequirePermission permission={PERMISSIONS.MANAGE_ORG_STRUCTURE}><BusinessUnit /></RequirePermission>,
  },
  {
    path: "/sitelocation",
    element: <RequirePermission permission={PERMISSIONS.MANAGE_ORG_STRUCTURE}><Sitelocation /></RequirePermission>,
  },
  {
    path: "/listofentities",
    element: <RequirePermission permission={PERMISSIONS.MANAGE_ORG_STRUCTURE}><Listofentities /></RequirePermission>,
  },
  {
    path: "/listsitelocations",
    element: <RequirePermission permission={PERMISSIONS.MANAGE_ORG_STRUCTURE}><ListSiteLocations /></RequirePermission>,
  },
  {
    path: "/organizations",
    element: <RequirePermission permission={PERMISSIONS.PLATFORM_STAFF}><Organizations /></RequirePermission>,
  },
  {
    path: "/organizations/new",
    element: <RequirePermission permission={PERMISSIONS.PLATFORM_STAFF}><OrganizationNew /></RequirePermission>,
  },
  {
    path: "/adduser",
    element: <RequirePermission permission={PERMISSIONS.MANAGE_USERS_ROLES}><AddUser /></RequirePermission>,
  },
  {
    path: "/listofusers",
    element: <RequirePermission permission={PERMISSIONS.MANAGE_USERS_ROLES}><Listofusers /></RequirePermission>,
  },
  {
    path: "/listofbusinessunits",
    element: <RequirePermission permission={PERMISSIONS.MANAGE_ORG_STRUCTURE}><Listofbusinessunits /></RequirePermission>,
  },
  {
    path: "/accessdenied",
    element: <Accessdenied />,
  },
  {
    path: "/comingsoon",
    element: <Comingsoon />,
  },
  {
    path: "/coming-soon",
    element: <ComingSoonForms />,
  },
  {
    path: "/coming-soon-eol",
    element: <ComingSoonForms />,
  },
  {
    path: "/coming-soon-logistics",
    element: <ComingSoonForms />,
  },
  {
    path: "/coming-soon-packaging",
    element: <ComingSoonForms />,
  },
  {
    path: "/forms-apps",
    element: <RequireFeature feature="forms"><FormsApps /></RequireFeature>,
  },
  {
    path: "/employee-commute-data",
    element: <RequireFeature feature="forms.commute"><EmployeeCommuteSurvey /></RequireFeature>,
  },
  {
    path: "/start-new-survey",
    element: <RequireFeature feature="forms.commute"><StartNewSurvey /></RequireFeature>,
  },
  {
    path: "employee-commute",
    element: <RequireFeature feature="forms.commute"><ECDashboard /></RequireFeature>,
  },
  {
    path: "employee-commute-survey",
    element: <RequireFeature feature="forms.commute"><ECSurveyForm /></RequireFeature>,
  },
  {
    path: "supplier-carbon-footprint",
    element: <RequireFeature feature="forms.supplier-footprint"><SCFData /></RequireFeature>,
  },
  {
    path: "supplier-carbon-footprint-survey",
    element: <RequireFeature feature="forms.supplier-footprint"><SCFSurvey /></RequireFeature>,
  },
  {
    path: "supplier-carbon-footprint-survey-form",
    element: <RequireFeature feature="forms.supplier-footprint"><SCFSurveyForm /></RequireFeature>,
  },
  {
    path: "energy-emissions",
    element: <SCFEnergyEmissions />,
  },

  {
    path: "energy-emissions-scope",
    element: <SCFScope />,
  },
  {
    path: "repository",
    element: <Repository />,
  },
  {
    path: "add-more",
    element: <RepositoryAddLink />,
  },
  // {
  //   path: "esg-benchmarking",
  //   element: <ESGBenchmarking />,
  // },
  {
    path: "/insights",
    element: <RequireFeature feature="insights"><Insights /></RequireFeature>,
  },
  {
    path: "/advisor",
    element: <RequireFeature feature="insights"><RequirePermission permission={PERMISSIONS.ACCESS_AI_INSIGHTS}><ProtectedRoute><AdvisorPage /></ProtectedRoute></RequirePermission></RequireFeature>,
  },
  {
    path: "/assessing-low-re",
    element: <RequireFeature feature="insights"><Assessinglowre /></RequireFeature>,
  },
  {
    path: "/electricity-cost-evaluation",
    element: <RequireFeature feature="insights"><Electricitycostevaluation /></RequireFeature>,
  },
  {
    path: "/assessing-elec-usage",
    element: <RequireFeature feature="insights"><Assessingelecusage /></RequireFeature>,
  },
  {
    path: "/reporting",
    element: <Reporting />,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/reporting",
    element: <Reporting />,
  },
  {
    path: "/internal",
    element: <RequireFeature feature="reports.internal"><Internal /></RequireFeature>,
  },
  {
    path: "/standards",
    element: <RequireFeature feature="reports.frameworks"><Standards /></RequireFeature>,
  },
  {
    path: "/csrd",
    element: <RequireFeature feature="reports.frameworks.csrd"><RequirePermission permission={PERMISSIONS.START_ASSESSMENTS}><Csrd /></RequirePermission></RequireFeature>,
  },
  {
    path: "/brsr/new-report",
    element: <RequireFeature feature="reports.frameworks.brsr"><RequirePermission permission={PERMISSIONS.START_ASSESSMENTS}><BrsrNewReport /></RequirePermission></RequireFeature>,
  },
  {
    path: "/brsr/repository",
    element: <RequireFeature feature="reports.frameworks.brsr"><RequirePermission permission={PERMISSIONS.START_ASSESSMENTS}><BrsrRepository /></RequirePermission></RequireFeature>,
  },
  {
    path: "/brsr/input",
    element: <RequireFeature feature="reports.frameworks.brsr"><RequirePermission permission={PERMISSIONS.START_ASSESSMENTS}><BrsrModule /></RequirePermission></RequireFeature>,
  },
  {
    path: "/brsr/preview-report",
    element: <RequireFeature feature="reports.frameworks.brsr"><BrsrPreviewReport /></RequireFeature>,
  },
  {
    path: "/brsr/dashboard",
    element: <RequireFeature feature="reports.frameworks.brsr"><BrsrDashboard /></RequireFeature>,
  },
  {
    path: "/GenerateReport",
    element: <RequireFeature feature="reports.frameworks.csrd"><RequirePermission permission={PERMISSIONS.START_ASSESSMENTS}><GenerateReport /></RequirePermission></RequireFeature>,
  },
  {
    path: "/displayLabels",
    element: <DisplayLabels />,
  },
  {
    path: "/csrd1",
    element: <RequireFeature feature="reports.frameworks.csrd"><Csrd1 /></RequireFeature>,
  },
  {
    path: "/home",
    element: <Home />,
  },
  {
    path: "/ReportingModules",
    element: <RequireFeature feature="reports.frameworks.csrd"><RequirePermission permission={PERMISSIONS.START_ASSESSMENTS}><ReportingModules /></RequirePermission></RequireFeature>,
  },

  {
    path: "/ReportTable",
    element: <RequireFeature feature="reports.frameworks.csrd"><ReportTable /></RequireFeature>,
  },
  {
    path: "/Materiality",
    element: <RequireFeature feature="reports.frameworks.csrd"><RequirePermission permission={PERMISSIONS.START_ASSESSMENTS}><Materiality /></RequirePermission></RequireFeature>,
  },
  {
    path: "/PreviewReport",
    element: <RequireFeature feature="reports.frameworks.csrd"><PreviewReport /></RequireFeature>,
  },
  {
    path: "/Form",
    element: <FormApp />,
  },
  {
    path: "/Table",
    element: <Table />,
  },
  {
    path: "/demo",
    element: <Carousel />,
  },
  {
    path: "/reportDashboard",
    element: <ReportDashboard />,
  },
  {
    path: "/social",
    element: <RequireFeature feature="dashboard.social"><Social /></RequireFeature>,
  },
  {
    path: "/demotable",
    element: <Demotable />,
  },
  {
    path: "/demonew",
    element: <Demonew />,
  },
  {
    path: "/scope2",
    element: <RequireFeature feature="dashboard.environment.electricity"><Scope2 /></RequireFeature>,
  },
  {
    path: "/scope1",
    element: <RequireFeature feature="dashboard.environment.scope1"><Scope1 /></RequireFeature>,
  },
  {
    path: "/editConfiguration",
    element: <RequireFeature feature="configuration"><RequirePermission permission={PERMISSIONS.MANAGE_CONFIGURATION}><EditConfiguration /></RequirePermission></RequireFeature>,
  },
  {
    path: "/newconfig",
    element: <RequireFeature feature="configuration"><RequirePermission permission={PERMISSIONS.MANAGE_CONFIGURATION}><Newconfig /></RequirePermission></RequireFeature>,
  },
  {
    path: "/neweditconfig",
    element: <RequireFeature feature="configuration"><RequirePermission permission={PERMISSIONS.MANAGE_CONFIGURATION}><Neweditconfig /></RequirePermission></RequireFeature>,
  },
  {
    path: "/newallconfig",
    element: <RequireFeature feature="configuration"><RequirePermission permission={PERMISSIONS.MANAGE_CONFIGURATION}><Newallconfig /></RequirePermission></RequireFeature>,
  },
  {
    path: "/editcsrd",
    element: <RequireFeature feature="reports.frameworks.csrd"><RequirePermission permission={PERMISSIONS.START_ASSESSMENTS}><EditCSRD /></RequirePermission></RequireFeature>,
  },
  {
    path: "/editmateriality",
    element: <RequireFeature feature="reports.frameworks.csrd"><RequirePermission permission={PERMISSIONS.START_ASSESSMENTS}><EditMateriality /></RequirePermission></RequireFeature>,
  },
  {
    path: "/editreportingmodule",
    element: <RequireFeature feature="reports.frameworks.csrd"><RequirePermission permission={PERMISSIONS.START_ASSESSMENTS}><EditReportingModule /></RequirePermission></RequireFeature>,
  },
  {
    path: "/editgeneratereport",
    element: <RequireFeature feature="reports.frameworks.csrd"><RequirePermission permission={PERMISSIONS.START_ASSESSMENTS}><EditGenerateReport /></RequirePermission></RequireFeature>,
  },
  {
    path: "/editpreviewreport",
    element: <RequireFeature feature="reports.frameworks.csrd"><EditPreviewReport /></RequireFeature>,
  },
  {
    path: "/Employee-commute-dashboard",
    element: <RequireFeature feature="dashboard.environment.commute"><Employeecommutedashboard /></RequireFeature>,
  },
  {
    path: "/Business-travel-dashboard",
    element: <RequireFeature feature="dashboard.environment.business-travel"><Businesstraveldashboard /></RequireFeature>,
  },
  {
    path: "/Transportation-Distribution-Dashboard",
    element: <RequireFeature feature="dashboard.environment.transport-distribution"><Transportationdistributiondashboard /></RequireFeature>,
  },
  {
    path: "/Travel-Logistic-Dashboard",
    element: <RequireFeature feature="dashboard.environment.travel-logistics"><Travellogisticdashboard /></RequireFeature>,
  },
  {
    path: "/water",
    element: <RequireFeature feature="dashboard.environment.water"><Water /></RequireFeature>,
  },
  {
    path: "/waste-dashboard",
    element: <RequireFeature feature="dashboard.environment.waste"><Wastedashboard /></RequireFeature>,
  },
  {
    path: "/waste-supplier-factors",
    element: <RequireFeature feature="configuration"><RequirePermission permission={PERMISSIONS.MANAGE_CONFIGURATION}><WasteSupplierFactors /></RequirePermission></RequireFeature>,
  },
  {
    path: "/waste-factors",
    element: <RequirePermission permission={PERMISSIONS.PLATFORM_STAFF}><WasteFactorLibrary /></RequirePermission>,
  },
  {
    path: "/internal-reports",
    element: <RequireFeature feature="reports.internal"><InternalReports /></RequireFeature>,
  },
  {
    path: "/esg-dashboard",
    element: <RequireFeature feature="dashboard"><ESGDashboard /></RequireFeature>,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/Emission-targets",
    element: <RequireFeature feature="insights"><EmissionTargets /></RequireFeature>,
  },
  {
    path: "/Emission-benchmarking",
    element: <RequireFeature feature="insights"><ProtectedRoute><EmissionBenchmarking /></ProtectedRoute></RequireFeature>,
  },
  {
    path: "/ESG-reporting-SF",
    element: <ESGReportingSF />,
  },
  {
    path: "/glossary",
    element: <ProtectedRoute><Glossary /></ProtectedRoute>,
  },
  {
    path: "/framework-guides",
    element: <ProtectedRoute><FrameworkGuides /></ProtectedRoute>,
  },
  {
    path: "/esg-benchmarking",
    element: <RequireFeature feature="insights"><ProtectedRoute><ESGHome /></ProtectedRoute></RequireFeature>,
  },
  {
    path: "/csrd-benchmarking",
    element: <RequireFeature feature="insights"><ProtectedRoute><CsrdBenchmarkingV2 /></ProtectedRoute></RequireFeature>,
  },
  {
    path: "/csrd-benchmarking-legacy",
    element: <RequireFeature feature="insights"><ProtectedRoute><CsrdBenchmarking /></ProtectedRoute></RequireFeature>,
  },
  {
    path: "/report-history",
    element: <ReportHistoryNew />,
  },
  {
    path: "/deep-dive",
    element: <RequireFeature feature="insights"><DeepDivePage /></RequireFeature>,
  },
  {
    path: "/edit-configuration",
    element: <RequireFeature feature="configuration"><EditConfig /></RequireFeature>,
  },
  {
    path: "/performance-dashboard",
    element: <RequireFeature feature="dashboard"><PerformanceDashboardPage /></RequireFeature>,
  },
]);

/**
 * The main app which handles the initialization and routing
 * of the app.
 */
export default function App() {
  return <RouterProvider router={router} />;
}
